<template>
    <header>
        <router-link :to="{name: back_path, params: {back: 'true'}}"   class="outline"><img v-if="back=='true'" class="back" src="../assets/images/back.png"></router-link>
        <h2>{{ title }}</h2>
        <router-link :to="{name: path}" class="outline"><img class="close" @click="$emit('close')" v-if="close=='true'"
                                                             src="../assets/images/close.png"></router-link>
        <span v-if="profil=='true'">Speichern</span>
    </header>
</template>

<script>
    export default {
        props: ['title', 'close', 'path','back_path','back', 'profil'],
        data() {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/css/style';
    header {
        background-color: $lila;
        position: fixed;
        width: 100%;
        top: 0;

        h2 {
            padding: 24px 0 3px 0;
            color: $betuszin;
            text-align: center;
            font-size: 2.0rem;
            font-weight: 200;
            line-height: 28px;
            font-family: "SF UI Text Light";
            letter-spacing: -0.4375px;
        }

        img{
            position: absolute;
            &.back{
                top: 25px;
                left: 20px;
            }
            &.close
            {
                top: 30px;
                right: 20px;
            }
        }
        span{
            position: absolute;
            top:28px;
            right:20px;
            font-size: 1.5rem;
            letter-spacing: -0,4375px;
            font-weight: 500;
            color: $betuszin;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue